import styled from 'styled-components';
import { BodyRegularS, LabelRegularBoldM } from '../../../../styles/globals';
import { IThemeProvider } from '../../../../styles/theme';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 17px;
  letter-spacing: 0.08em;
  ${({ theme }: IThemeProvider) => `
    margin-top: ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[90]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0.8rem 0 2rem 0;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
  `}
`;

export const Description = styled.div`
  letter-spacing: 0.07px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 24px;
`;

export const Title = styled(LabelRegularBoldM)`
  padding: 0.5rem 0;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]}
  `}
`;

export const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow: auto;
  ${({ theme }: IThemeProvider) => `
  transition: linear 0.5s;
    
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${theme.colors.secondary[30]};
    border-radius: 4px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.secondary[70]};
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.secondary[100]};
  }
  `}
`;

export const SingleQuestionBlock = styled.div`
  padding: 1rem 3rem;
  margin-top: 0.5rem;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
  `}
`;

export const InnerText = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const NoTopic = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.accent.red[100]};
  `}
`;
